import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export function Layout() {
  return (
    <div className="h-screen bg-background overflow-hidden">
      <div className="flex h-full">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <Header />
          <main className="flex-1 flex flex-col min-h-0 p-6 overflow-hidden w-full">
            <div className="max-w-[1600px] mx-auto w-full flex-1 min-h-0 flex flex-col">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}